import { Injectable } from "@angular/core";
import { HttpClient, HttpHeaders } from "@angular/common/http";
import { JwtHelperService } from "@auth0/angular-jwt";
import { BaseEntityService } from "./rest-common.service";
import { ActivatedRoute, Router } from "@angular/router";
import { Observable } from 'rxjs';

@Injectable({
  providedIn: "root",
})
export class AuthService extends BaseEntityService {
  constructor(public http: HttpClient,
    private router: Router,
    private route: ActivatedRoute) {
    super();

    const jwtHelper = new JwtHelperService();
  }

  public resource_url = `${this.BASE_API_URL}/auth/`;
  signIn(data): Observable<any> {

    return this.post(`${this.BASE_API_URL}/token/`, data)
  }

  getJWT(clientId, clientType) {
    if(clientId && clientType) {
      return this.get(`${this.BASE_API_URL}/user/qlik-token/?${clientType}=${clientId}`)
    }
    return this.get(`${this.BASE_API_URL}/user/qlik-token/`)
  }

  logToQlik(url, id, webToken) {
    let data = null
    return this.post(`${url}`, data)
  }

  checkLogin(url) {
    return this.get(`${url}api/v1/users/me`)
  }

  logoutUser(isAccesTokenExpired: boolean = false) {

    this.signOut()
    if (isAccesTokenExpired) {
      let returnURL = this.router.url;
      this.router.navigate(['/signin'], {
        queryParams: { returnUrl: returnURL }
      });
    } else {
      this.router.navigate(['/signin']);
    }
  }

  signOut() {
    // localStorage.removeItem("token");
    // localStorage.removeItem('role')
    // localStorage.removeItem('advertiser')
    // localStorage.removeItem('agency')
    // localStorage.removeItem('user')
    localStorage.clear();
  }

  refreshToken() {
    // console.log('refresh token called')
    const refresh_token = localStorage.getItem("refresh")
    let url = `${this.BASE_API_URL}/token/refresh/`
    return this.http.post(url, { "refresh": refresh_token })
  }

  passwordValidate(token) {
    return this.post(`${this.BASE_API_URL}/auth/password-reset/validate-token/`, token)
  }

  passwordReset(token, password) {
    return this.post(`${this.BASE_API_URL}/auth/password-reset/confirm/?token=${token}`, password)
  }

  changeUserPasswordRequest(email: any) {
    return this.post(`${this.BASE_API_URL}/auth/password-reset/`, email);
  }


  verifyToken(token) {
    let url = `${this.BASE_API_URL}/token/verify/`
    return this.http.post(url, { "token": token })
  }

  isAuthenticated() {
    // return true;
    const token = localStorage.getItem("token");
    return !!token;
  }

  verifyCode(params={}, data) {
    let url = this.buildUrl(`${this.BASE_API_URL}/token/verify-code/`, '', params);
    return this.post(url, data)
  }
}
